import React, { useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import data from "../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';


const ImportData = (props) => {
  var accessToken = props.oidc.user.access_token;  

  const [expired, setExpired] = useState("");

  const onFileChange = event => {

  setExpired({ ...expired, selectedFile: event.target.files[0] });  
   
  };
 
  const onFileUpload = async (e) => {

    var ext =  expired.selectedFile.name.substr(expired.selectedFile.name.lastIndexOf('.') + 1);    
 
     if(ext != "csv" && ext != "txt")
     {
        notify({
          message: 'File extenstion should be csv or txt.',
          width: 150}, 'error', 2000);
          return;
     }
      // Create an object of formData
     const formData = new FormData();
      
     var filePath = "";
     if(props.oidc.user.profile.hasOwnProperty("WMIMPORTFILESPATH"))
     {
        filePath = props.oidc.user.profile.WMIMPORTFILESPATH;        
     }
      // Update the formData object
      formData.append(
        "File", 
        expired.selectedFile     
      );     
      
    formData.append("filePath", filePath); 
    try
    {   
      const result = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.ImportData.ImportCSVData}`,
        formData,    
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      );
      if(result.status == 200)
      {
        notify({
          message: 'File uploaded successfully.',
          width: 150}, 'success', 2000);

      }
      else
      {
        notify({
          message: 'Invalid file.',
          width: 150}, 'error', 2000);
      }
    }
    catch(err)
    {
      notify({
        message: 'Invalid file.',
        width: 150}, 'error', 2000);
    }  
  };

    
  const fileData = () => {
     
    if (expired.selectedFile) {
        
      return (        
        <div>
          <h4>File Details:</h4>
          <p style={{fontWeight:"500"}}> File Name: {expired.selectedFile.name}</p>  
          <p style={{fontWeight:"500"}}> File Type: {expired.selectedFile.type}</p>         

        </div>
      );
    } 
  }; 
   
  return (
    <div className="row WMImportDataPageHeight" style={{backgroundColor:'#fff'}}>
      <div className="col-md-12 main-page">
        <div style={{marginLeft:'12px'}}>
          <Toolbar className="header">
            <Item location="before">
                <div className="title">
                    <h6 style={{color: window._env_.Color2}}>
                        Import Data
                    </h6>
                </div>
            </Item>
          </Toolbar>
          <div>
            <br/>
            <p style={{fontWeight: "700" }}>
                Only files with extension csv or txt are allowed, also files are limited by size up to 100 kb</p>
          </div>
          <div>
            <label htmlFor="file-upload" className="custom-file-upload">
              <i className="fa fa-cloud-upload" style={{fontWeight:"500"}}></i> Upload Csv or Txt File
            </label>
            <input id="file-upload" type="file" onChange={onFileChange} style={{display:"none"}} />
            <div style={{marginBottom:'12px'}}>
              <Button  text="Upload!" onClick={onFileUpload} type="default"></Button>             
            </div>
          </div>
          <div style={{marginBottom:'12px'}}>
            {fileData()}
          </div>
        </div>
      </div>
    </div>

  );
  

};

function mapStateToProps(state) {
  return {  
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(ImportData);
